import { render } from "./LearnArticle.vue?vue&type=template&id=b4431b2c&scoped=true"
import script from "./LearnArticle.vue?vue&type=script&lang=js"
export * from "./LearnArticle.vue?vue&type=script&lang=js"

import "./LearnArticle.vue?vue&type=style&index=0&id=b4431b2c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4431b2c"]])

export default __exports__